"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteHeaderStatus = void 0;
var RequestForQuoteHeaderStatus;
(function (RequestForQuoteHeaderStatus) {
    RequestForQuoteHeaderStatus["NEW"] = "new";
    RequestForQuoteHeaderStatus["ACKNOWLEDGED"] = "acknowledged";
    RequestForQuoteHeaderStatus["IN_PROCESS"] = "in-process";
    RequestForQuoteHeaderStatus["QUOTE_SENT"] = "quote-sent";
})(RequestForQuoteHeaderStatus = exports.RequestForQuoteHeaderStatus || (exports.RequestForQuoteHeaderStatus = {}));
//# sourceMappingURL=request-for-quote-header-status.enum.js.map